(() => {
  const configElement = document.querySelector('[data-hoo-popup-enhancer]');

  if (!configElement) return;

  const config = {
    image: configElement.dataset.hooPopupImage || '',
    logo: configElement.dataset.hooPopupLogo || '',
    mediaMode: configElement.dataset.hooPopupMediaMode || 'photo',
    maxWidth: Number.parseInt(configElement.dataset.hooPopupMaxWidth || '720', 10),
    heading: configElement.dataset.hooPopupHeading || '15% έκπτωση στην πρώτη σου παραγγελία',
    text: configElement.dataset.hooPopupText || 'Γράψου και κέρδισε άμεσα το προνόμιό σου.',
    consent:
      configElement.dataset.hooPopupConsent ||
      'Συμφωνώ να λαμβάνω νέα, προσφορές και ενημερώσεις μέσω email.',
    button: configElement.dataset.hooPopupButton || 'Κέρδισε 15% έκπτωση',
  };

  const popupWidth = Number.isFinite(config.maxWidth)
    ? Math.min(820, Math.max(560, config.maxWidth))
    : 720;

  const styles = `
    #pc-modal-backdrop {
      position: fixed !important;
      inset: 0 !important;
      z-index: 2147483000 !important;
      display: grid !important;
      place-items: center !important;
      width: 100vw !important;
      height: 100svh !important;
      padding: 16px !important;
      overflow: auto !important;
      background: rgb(18 15 12 / 52%) !important;
      box-sizing: border-box !important;
    }

    #pc-modal-backdrop .modal-card {
      position: relative !important;
      inset: auto !important;
      width: min(${popupWidth}px, calc(100vw - 32px)) !important;
      height: auto !important;
      max-width: ${popupWidth}px !important;
      max-height: calc(100svh - 32px) !important;
      margin: auto !important;
      overflow: hidden !important;
      border: 1px solid rgb(31 27 23 / 12%) !important;
      border-radius: 2px !important;
      background: #fff !important;
      box-shadow: 0 24px 80px rgb(18 15 12 / 28%) !important;
    }

    #pc-modal-backdrop .modal-hero-container {
      display: grid !important;
      grid-template-columns: minmax(210px, 0.42fr) minmax(0, 0.58fr) !important;
      width: 100% !important;
      height: auto !important;
      max-height: calc(100svh - 32px) !important;
      overflow: hidden !important;
      background: #fff !important;
    }

    #pc-modal-backdrop .modal-hero-image {
      display: block !important;
      width: 100% !important;
      min-width: 0 !important;
      min-height: 100% !important;
      background-color: #f5f0e9 !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
      background-size: contain !important;
    }

    #pc-modal-backdrop .modal-content {
      width: 100% !important;
      height: auto !important;
      max-height: calc(100svh - 32px) !important;
      overflow-x: hidden !important;
      overflow-y: auto !important;
      background: #fff !important;
    }

    #pc-modal-backdrop .pop-content-blocks,
    #pc-modal-backdrop .blocks-renderer {
      width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      padding: 0 !important;
      margin: 0 !important;
      box-shadow: none !important;
      box-sizing: border-box !important;
    }

    #pc-modal-backdrop .blocks-renderer {
      display: flex !important;
      flex-direction: column !important;
      gap: 10px !important;
      padding: 26px 28px 24px !important;
    }

    #pc-modal-backdrop #block-1,
    #pc-modal-backdrop #block-3,
    #pc-modal-backdrop #block-6,
    #pc-modal-backdrop #block-1 .block-content,
    #pc-modal-backdrop #block-3 .block-content {
      width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      box-sizing: border-box !important;
    }

    #pc-modal-backdrop [block-type='divider'],
    #pc-modal-backdrop #block-5[block-type='text'] {
      display: none !important;
    }

    #pc-modal-backdrop [block-type='form'],
    #pc-modal-backdrop [block-type='form'] .block-content {
      display: block !important;
      width: 100% !important;
      height: auto !important;
      margin: 0 !important;
      padding: 0 !important;
      box-sizing: border-box !important;
    }

    #pc-modal-backdrop #block-1 h1 {
      margin: 0 28px 8px 0 !important;
      color: #171411 !important;
      font-family: Georgia, 'Times New Roman', serif !important;
      font-size: clamp(25px, 3vw, 32px) !important;
      font-weight: 500 !important;
      line-height: 1.05 !important;
      letter-spacing: -0.025em !important;
    }

    #pc-modal-backdrop #block-1 p {
      margin: 0 !important;
      color: #675f57 !important;
      font-size: 14px !important;
      line-height: 1.45 !important;
    }

    #pc-modal-backdrop .form-block,
    #pc-modal-backdrop form {
      width: 100% !important;
      max-width: none !important;
      gap: 9px !important;
      margin: 0 !important;
      box-sizing: border-box !important;
    }

    #pc-modal-backdrop .bar-input-form,
    #pc-modal-backdrop .form-block-input-container {
      display: flex !important;
      flex-direction: column !important;
      width: 100% !important;
      height: auto !important;
      min-height: 0 !important;
      gap: 4px !important;
      margin: 0 !important;
    }

    #pc-modal-backdrop .form-block-label,
    #pc-modal-backdrop label:not(.gdpr-label) {
      color: #29241f !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      line-height: 1.25 !important;
    }

    #pc-modal-backdrop input:not([type='checkbox']),
    #pc-modal-backdrop .form-block-input,
    #pc-modal-backdrop .form-block-input-new {
      width: 100% !important;
      height: 42px !important;
      min-height: 42px !important;
      padding: 9px 12px !important;
      border: 1px solid #d8d1ca !important;
      border-radius: 0 !important;
      background: #fff !important;
      color: #171411 !important;
      font-size: 16px !important;
      box-sizing: border-box !important;
    }

    #pc-modal-backdrop input:focus {
      border-color: #171411 !important;
      outline: 1px solid #171411 !important;
      outline-offset: 1px !important;
    }

    #pc-modal-backdrop .gdpr-label,
    #pc-modal-backdrop [class*='gdpr'] label {
      color: #675f57 !important;
      font-size: 11px !important;
      line-height: 1.35 !important;
    }

    #pc-modal-backdrop button[type='submit'],
    #pc-modal-backdrop .form-block button {
      width: 100% !important;
      min-height: 44px !important;
      margin-top: 2px !important;
      border: 1px solid #171411 !important;
      border-radius: 0 !important;
      background: #171411 !important;
      color: #fff !important;
      font-size: 13px !important;
      font-weight: 700 !important;
      letter-spacing: 0.06em !important;
      text-transform: uppercase !important;
    }

    #pc-modal-backdrop button[type='submit']:hover {
      background: #75634f !important;
      border-color: #75634f !important;
    }

    #pc-main-close-button {
      top: 10px !important;
      right: 10px !important;
      z-index: 10 !important;
      width: 34px !important;
      height: 34px !important;
      border-radius: 50% !important;
      background: rgb(255 255 255 / 90%) !important;
      color: #171411 !important;
      box-shadow: 0 2px 14px rgb(18 15 12 / 12%) !important;
    }

    @media (max-width: 749px) {
      #pc-modal-backdrop {
        padding: 10px !important;
      }

      #pc-modal-backdrop .modal-card {
        width: min(390px, calc(100vw - 20px)) !important;
        max-height: calc(100svh - 20px) !important;
      }

      #pc-modal-backdrop .modal-hero-container {
        display: block !important;
        max-height: calc(100svh - 20px) !important;
      }

      #pc-modal-backdrop .modal-hero-image {
        width: 100% !important;
        height: 200px !important;
        min-height: 200px !important;
        background-position: center !important;
        background-size: contain !important;
      }

      #pc-modal-backdrop .modal-content {
        max-height: calc(100svh - 220px) !important;
      }

      #pc-modal-backdrop .blocks-renderer {
        gap: 8px !important;
        padding: 16px 18px 17px !important;
      }

      #pc-modal-backdrop #block-1 h1 {
        margin-right: 30px !important;
        margin-bottom: 5px !important;
        font-size: 24px !important;
      }

      #pc-modal-backdrop #block-1 p {
        font-size: 13px !important;
      }

      #pc-modal-backdrop input:not([type='checkbox']),
      #pc-modal-backdrop .form-block-input,
      #pc-modal-backdrop .form-block-input-new {
        height: 40px !important;
        min-height: 40px !important;
      }

      #pc-modal-backdrop button[type='submit'],
      #pc-modal-backdrop .form-block button {
        min-height: 42px !important;
      }
    }

    @media (max-height: 680px) and (max-width: 749px) {
      #pc-modal-backdrop .modal-hero-image {
        height: 120px !important;
        min-height: 120px !important;
      }

      #pc-modal-backdrop .modal-content {
        max-height: calc(100svh - 140px) !important;
      }

      #pc-modal-backdrop .blocks-renderer {
        padding-top: 13px !important;
        padding-bottom: 13px !important;
      }
    }
  `;

  const updateTextNode = (element, value) => {
    if (!element || !value || element.textContent.trim() === value) return;

    // Preserve the app's checkbox, links and event handlers while translating.
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) {
      if (walker.currentNode.textContent.trim()) textNodes.push(walker.currentNode);
    }
    if (!textNodes.length) return;
    textNodes[0].textContent = value;
    textNodes.slice(1).forEach((node) => { node.textContent = ''; });
  };

  const translateForm = (root) => {
    const campaign = root.querySelector('.pc-campaign-363397') || root.querySelector('.pop-content-blocks');
    if (!campaign) return;

    updateTextNode(campaign.querySelector('#block-1 h1'), config.heading);
    updateTextNode(campaign.querySelector('#block-1 p'), config.text);
    campaign.querySelectorAll('#block-1 p').forEach((paragraph) => {
      if (paragraph.textContent.trim().toLowerCase() === 'subscribe to get a discount code.') {
        updateTextNode(paragraph, 'Συμπλήρωσε το email σου για να λάβεις τον κωδικό έκπτωσης.');
      }
    });

    campaign.querySelectorAll('label, .form-block-label').forEach((label) => {
      const current = label.textContent.trim().toLowerCase();
      if (current === 'name') updateTextNode(label, 'Όνομα');
      if (current === 'birthday') updateTextNode(label, 'Ημερομηνία γέννησης');
    });

    campaign.querySelectorAll('input').forEach((input) => {
      const placeholder = (input.getAttribute('placeholder') || '').toLowerCase();
      if (placeholder.includes('your name')) input.setAttribute('placeholder', 'Το όνομά σου');
      if (placeholder.includes('youremail') || placeholder.includes('your email')) {
        input.setAttribute('placeholder', 'Το email σου');
      }
    });

    const consent = Array.from(campaign.querySelectorAll('label.gdpr-label, label')).find((element) =>
      element.textContent.trim().toLowerCase().startsWith('i agree to subscribe')
    );
    updateTextNode(consent, config.consent);

    const submitButton = campaign.querySelector("button[type='submit']") || campaign.querySelector('#block-3 button');
    if (submitButton && submitButton.textContent.trim() !== config.button) {
      submitButton.textContent = config.button;
    }
  };

  const applyMedia = (root) => {
    const media = root.querySelector('.modal-hero-image');
    if (!media) return;

    const useLogo = config.mediaMode === 'logo' && config.logo;
    const mediaUrl = useLogo ? config.logo : config.image;
    if (!mediaUrl) return;

    media.style.setProperty('background-image', `url("${mediaUrl.replace(/"/g, '\\"')}")`, 'important');
    media.style.setProperty('background-size', useLogo ? '72% auto' : 'contain', 'important');
    media.style.setProperty('background-position', 'center', 'important');
  };

  let observedRoot;
  let rootObserver;
  let refreshQueued = false;

  const refresh = (root) => {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(() => {
      refreshQueued = false;
      translateForm(root);
      applyMedia(root);
    });
  };

  const install = () => {
    const host = document.querySelector('#pop-convert-app');
    const root = host?.shadowRoot;
    if (!root) return false;

    if (!root.querySelector('#hoo-pop-convert-overrides')) {
      const style = document.createElement('style');
      style.id = 'hoo-pop-convert-overrides';
      style.textContent = styles;
      root.append(style);
    }

    refresh(root);

    if (observedRoot !== root) {
      rootObserver?.disconnect();
      observedRoot = root;
      rootObserver = new MutationObserver(() => refresh(root));
      rootObserver.observe(root, { childList: true, subtree: true, characterData: true });
    }

    return true;
  };

  const documentObserver = new MutationObserver(install);
  documentObserver.observe(document.documentElement, { childList: true, subtree: true });

  let attempts = 0;
  const poll = window.setInterval(() => {
    attempts += 1;
    install();
    if (attempts >= 120) window.clearInterval(poll);
  }, 250);

  install();
})();
